// src/components/dfs/skeletons/TableRankingRowSkeleton.tsx
import React from 'react';

const TableRankingRowSkeleton: React.FC = () => {
  return (
    <tr className="animate-pulse">
      {/* Rank placeholder - adjusted width and alignment to better match typical table */}
      <td className="p-2 w-12 text-left">
        <div className="h-4 bg-gray-600/50 rounded w-3/4"></div>
      </td>
      {/* User placeholder - adjusted width and alignment */}
      <td className="p-2 text-left">
        <div className="h-4 bg-gray-600/50 rounded w-1/2"></div>
      </td>
      {/* Score placeholder - adjusted width and alignment */}
      <td className="p-2 text-right">
        <div className="h-4 bg-gray-600/50 rounded w-1/4 ml-auto"></div>
      </td>
    </tr>
  );
};

export default TableRankingRowSkeleton;